export type OfficeContactPrefillParams = {
  officeSlug: string;
  locationSlug?: string;
  locationCount: number;
};

export const buildOfficeContactQueryParams = ({
  officeSlug,
  locationSlug,
  locationCount,
}: OfficeContactPrefillParams): URLSearchParams => {
  const params = new URLSearchParams();
  params.set("office", officeSlug);

  if (locationCount > 1 && locationSlug) {
    params.set("location", locationSlug);
  }

  return params;
};

export const appendOfficeContactQueryToHref = (
  href: string,
  prefill: OfficeContactPrefillParams,
): string => {
  const [path, existingQuery] = href.split("?");
  const merged = new URLSearchParams(existingQuery);
  for (const [key, value] of buildOfficeContactQueryParams(prefill)) {
    merged.set(key, value);
  }
  const queryString = merged.toString();
  return queryString ? `${path}?${queryString}` : path;
};
